// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.experiments-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.experiments-section-doc-preview {
  margin-bottom: 24px;
}

.experiments-section-doc-preview p {
  margin: 0 0 12px 0;
  color: #555;
  font-size: 14px;
}

.experiments-btn-primary {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background: #0d6efd;
  border: 1px solid #0d6efd;
  border-radius: 6px;
  cursor: pointer;
}

.experiments-btn-primary:hover {
  background: #0b5ed7;
  border-color: #0b5ed7;
}

.experiments-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #333;
}

.experiments-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.experiments-section {
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.experiments-section h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #555;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 10px;
}

.custom-tooltip {
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-tooltip p {
  margin: 4px 0;
  font-size: 14px;
}

.experiments-section-full {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.experiments-section-full h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #555;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 10px;
}

.market-description {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.market-item {
  margin-bottom: 12px;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.6;
}

.market-item strong {
  color: #333;
  margin-right: 8px;
}

.market-chart-container {
  margin-bottom: 20px;
  position: relative;
}

.market-radial-chart-wrapper {
  position: relative;
  width: 100%;
  height: 400px;
}

.market-radial-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.market-radial-layer > div {
  pointer-events: all;
}

.market-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 16px;
}

.market-color-indicator {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  margin-right: 10px;
  display: inline-block;
}

.market-item-desc {
  margin-left: 26px;
  color: #666;
  font-size: 14px;
}


/* ── 실험실 허브 ─────────────────────────────────────────────── */
.experiments-page {
  padding: 24px;
}

.experiments-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.experiments-back {
  background: #fff;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #344054;
}

.experiments-back:hover {
  background: #f2f4f7;
}

.experiments-hub-intro h2 {
  margin: 0 0 8px;
  font-size: 22px;
}

.experiments-hub-intro p {
  margin: 0 0 24px;
  color: #667085;
  line-height: 1.6;
}

.experiments-hub-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

.experiments-hub-card {
  background: #fff;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  padding: 20px;
  cursor: pointer;
  transition: border-color .15s, box-shadow .15s, transform .15s;
}

.experiments-hub-card:hover {
  border-color: #98a2b3;
  box-shadow: 0 4px 12px rgba(16, 24, 40, .08);
  transform: translateY(-2px);
}

.experiments-hub-icon {
  font-size: 28px;
  margin-bottom: 8px;
}

.experiments-hub-card h3 {
  margin: 0 0 6px;
  font-size: 16px;
}

.experiments-hub-card p {
  margin: 0 0 10px;
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}

.experiments-hub-card ul {
  margin: 0;
  padding-left: 18px;
  color: #98a2b3;
  font-size: 12px;
  line-height: 1.7;
}

/* ── 양식 복원 화면 ──────────────────────────────────────────── */
.restore-notice {
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: #fffaeb;
  border: 1px solid #fec84b;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 16px;
  font-size: 13px;
  line-height: 1.6;
  color: #7a5b00;
}

.restore-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
}

.restore-form label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #475467;
}

.restore-form select,
.restore-form input {
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  padding: 7px 10px;
  font-size: 14px;
}

.restore-form input[type="number"] {
  width: 90px;
}

.experiments-btn-secondary {
  background: #fff;
  color: #344054;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
}

.experiments-btn-secondary:hover:not(:disabled) {
  background: #f2f4f7;
}

.experiments-btn-secondary:disabled,
.experiments-btn-primary:disabled {
  opacity: .5;
  cursor: not-allowed;
}

.restore-error {
  margin-top: 12px;
  color: #b42318;
  font-size: 13px;
}

.restore-counts {
  margin-left: 10px;
  font-size: 13px;
  font-weight: normal;
  color: #667085;
}

.restore-sheet-table,
.restore-issue-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;
  font-size: 13px;
}

.restore-sheet-table th,
.restore-sheet-table td,
.restore-issue-table th,
.restore-issue-table td {
  border: 1px solid #e4e7ec;
  padding: 8px 10px;
  text-align: left;
  vertical-align: top;
}

.restore-sheet-table th,
.restore-issue-table th {
  background: #f9fafb;
  font-weight: 600;
}

.restore-issue-table td:first-child {
  width: 60px;
  white-space: nowrap;
}

.restore-issue-error td { background: #fef3f2; color: #b42318; }
.restore-issue-warn td { background: #fffaeb; color: #7a5b00; }
.restore-issue-info td { color: #475467; }

.restore-hint {
  font-size: 12px;
  color: #667085;
}
`, "",{"version":3,"sources":["webpack://./src/components/Experiments.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;;AAGA,8DAA8D;AAC9D;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;EAIE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;AAC/D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,yBAAyB,cAAc,EAAE;;AAEzC;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".experiments-container {\r\n  padding: 20px;\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.experiments-section-doc-preview {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.experiments-section-doc-preview p {\r\n  margin: 0 0 12px 0;\r\n  color: #555;\r\n  font-size: 14px;\r\n}\r\n\r\n.experiments-btn-primary {\r\n  padding: 10px 20px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #fff;\r\n  background: #0d6efd;\r\n  border: 1px solid #0d6efd;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.experiments-btn-primary:hover {\r\n  background: #0b5ed7;\r\n  border-color: #0b5ed7;\r\n}\r\n\r\n.experiments-title {\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n  margin-bottom: 30px;\r\n  color: #333;\r\n}\r\n\r\n.experiments-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.experiments-section {\r\n  background: white;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.experiments-section h3 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-bottom: 20px;\r\n  color: #555;\r\n  border-bottom: 2px solid #e0e0e0;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.custom-tooltip {\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  padding: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.custom-tooltip p {\r\n  margin: 4px 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.experiments-section-full {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  margin-top: 20px;\r\n}\r\n\r\n.experiments-section-full h3 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-bottom: 20px;\r\n  color: #555;\r\n  border-bottom: 2px solid #e0e0e0;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.market-description {\r\n  margin-top: 20px;\r\n  padding-top: 20px;\r\n  border-top: 1px solid #e0e0e0;\r\n}\r\n\r\n.market-item {\r\n  margin-bottom: 12px;\r\n  padding: 10px;\r\n  background: #f9f9f9;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.market-item strong {\r\n  color: #333;\r\n  margin-right: 8px;\r\n}\r\n\r\n.market-chart-container {\r\n  margin-bottom: 20px;\r\n  position: relative;\r\n}\r\n\r\n.market-radial-chart-wrapper {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 400px;\r\n}\r\n\r\n.market-radial-layer {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  pointer-events: none;\r\n}\r\n\r\n.market-radial-layer > div {\r\n  pointer-events: all;\r\n}\r\n\r\n.market-item-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n}\r\n\r\n.market-color-indicator {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 3px;\r\n  margin-right: 10px;\r\n  display: inline-block;\r\n}\r\n\r\n.market-item-desc {\r\n  margin-left: 26px;\r\n  color: #666;\r\n  font-size: 14px;\r\n}\r\n\r\n\n/* ── 실험실 허브 ─────────────────────────────────────────────── */\n.experiments-page {\n  padding: 24px;\n}\n\n.experiments-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.experiments-back {\n  background: #fff;\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  padding: 6px 12px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #344054;\n}\n\n.experiments-back:hover {\n  background: #f2f4f7;\n}\n\n.experiments-hub-intro h2 {\n  margin: 0 0 8px;\n  font-size: 22px;\n}\n\n.experiments-hub-intro p {\n  margin: 0 0 24px;\n  color: #667085;\n  line-height: 1.6;\n}\n\n.experiments-hub-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 16px;\n}\n\n.experiments-hub-card {\n  background: #fff;\n  border: 1px solid #e4e7ec;\n  border-radius: 10px;\n  padding: 20px;\n  cursor: pointer;\n  transition: border-color .15s, box-shadow .15s, transform .15s;\n}\n\n.experiments-hub-card:hover {\n  border-color: #98a2b3;\n  box-shadow: 0 4px 12px rgba(16, 24, 40, .08);\n  transform: translateY(-2px);\n}\n\n.experiments-hub-icon {\n  font-size: 28px;\n  margin-bottom: 8px;\n}\n\n.experiments-hub-card h3 {\n  margin: 0 0 6px;\n  font-size: 16px;\n}\n\n.experiments-hub-card p {\n  margin: 0 0 10px;\n  color: #667085;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.experiments-hub-card ul {\n  margin: 0;\n  padding-left: 18px;\n  color: #98a2b3;\n  font-size: 12px;\n  line-height: 1.7;\n}\n\n/* ── 양식 복원 화면 ──────────────────────────────────────────── */\n.restore-notice {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: #fffaeb;\n  border: 1px solid #fec84b;\n  border-radius: 8px;\n  padding: 14px 16px;\n  margin-bottom: 16px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #7a5b00;\n}\n\n.restore-form {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 12px;\n}\n\n.restore-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  color: #475467;\n}\n\n.restore-form select,\n.restore-form input {\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  padding: 7px 10px;\n  font-size: 14px;\n}\n\n.restore-form input[type=\"number\"] {\n  width: 90px;\n}\n\n.experiments-btn-secondary {\n  background: #fff;\n  color: #344054;\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  padding: 8px 16px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.experiments-btn-secondary:hover:not(:disabled) {\n  background: #f2f4f7;\n}\n\n.experiments-btn-secondary:disabled,\n.experiments-btn-primary:disabled {\n  opacity: .5;\n  cursor: not-allowed;\n}\n\n.restore-error {\n  margin-top: 12px;\n  color: #b42318;\n  font-size: 13px;\n}\n\n.restore-counts {\n  margin-left: 10px;\n  font-size: 13px;\n  font-weight: normal;\n  color: #667085;\n}\n\n.restore-sheet-table,\n.restore-issue-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 16px;\n  font-size: 13px;\n}\n\n.restore-sheet-table th,\n.restore-sheet-table td,\n.restore-issue-table th,\n.restore-issue-table td {\n  border: 1px solid #e4e7ec;\n  padding: 8px 10px;\n  text-align: left;\n  vertical-align: top;\n}\n\n.restore-sheet-table th,\n.restore-issue-table th {\n  background: #f9fafb;\n  font-weight: 600;\n}\n\n.restore-issue-table td:first-child {\n  width: 60px;\n  white-space: nowrap;\n}\n\n.restore-issue-error td { background: #fef3f2; color: #b42318; }\n.restore-issue-warn td { background: #fffaeb; color: #7a5b00; }\n.restore-issue-info td { color: #475467; }\n\n.restore-hint {\n  font-size: 12px;\n  color: #667085;\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
